
import Vue from 'vue'

export default Vue.extend({
  props: {
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      if (this.inverted) {
        return 'filter: drop-shadow(0px 100px 0 #22428a);  transform: translateY(-100px);';
      }
      return '';
    }
  }
})
